/**
 * Premium calculation helpers for policy amendments
 * Copied from PolicyAdmin/helpers to avoid complex import paths
 */

export function calculateTotalPremiumInCents(allbenefits) {
  if (!allbenefits || allbenefits.length < 1) return 0
  return allbenefits.reduce((total, benefit) => total + (benefit.premium_amount || 0), 0);
}

export function calculateMemberTotalPremiumInCents(member) {
  if (!member || !member.benefits || member.benefits.length < 1) return 0
  return calculateTotalPremiumInCents(member.benefits)
}

export const membersTotalPremiums = (members) => {
  let sum = 0;
  for (let member of members) {
    sum = sum + calculateMemberTotalPremiumInCents(member)
  }
  return sum / 100
}
